import React from "react";
import * as S from "./styles";
import TooltipComponent from "../tooltip/tooltipComponent";
import { getTranslateByKey } from "@/main/services/utils";
import { TypeRegisterStepScreen } from "@/main/screens/public/register/registerSteps/types";

interface IKOGStepperProps {
	steps: string[];
	currentStep: string;
	completedSteps?: string[];
	isLoading?: boolean;
	titleSteps?: Record<string, string>;
	onClickStep?: (step: string) => void;
	typeRegister: TypeRegisterStepScreen;
}

function KOGStepper({
	currentStep,
	steps,
	completedSteps = [],
	titleSteps,
	isLoading = false,
	onClickStep = () => {},
	typeRegister,
}: IKOGStepperProps) {
	const getPreviousStep = (step: string) => steps[steps.indexOf(step) - 1];
	const isActive = (step: string) => completedSteps.includes(step) || completedSteps.includes(getPreviousStep(step));
	const activeSteps = steps.slice(0, steps.indexOf(currentStep) + 1);
	function titleStep(step: string) {
		if (step === "Address" && typeRegister === "bodyshop") {
			return getTranslateByKey("information.stepDeliveryAddressData");
		}
		return titleSteps ? titleSteps[step] : step;
	}

	function handleClickStep(event: React.MouseEvent<HTMLDivElement>, step: string) {
		event.preventDefault();
		event.stopPropagation();
		const isNextStep = steps.indexOf(step) > steps.indexOf(currentStep) && !isActive(step);
		if (isNextStep || isLoading) return;

		onClickStep(step);
	}

	return (
		<S.Container>
			<S.ProgressBar />
			{steps.map((step, index) => (
				<TooltipComponent
					key={index}
					title={
						isActive(step) || currentStep === step
							? titleStep(step)
							: getTranslateByKey("information.completePreviousSteps")
					}
					placement="top"
				>
					<S.Step
						$isCompleted={activeSteps.includes(step) || currentStep === step}
						$isActive={isActive(step)}
						$isLoading={isLoading}
						onClick={(e) => handleClickStep(e, step)}
					>
						{++index}
					</S.Step>
				</TooltipComponent>
			))}
		</S.Container>
	);
}

export default KOGStepper;
